<template>
  <el-dialog :title="dialogTitle" :visible="visible" width="600px" :close-on-click-modal="false" class="page-dialog" @close="handleClose">
    <div class="dialog-content">
      <el-form ref="formRef" :model="localFormData" :rules="formRules" label-width="120px" size="small">
        <el-form-item label="客服类型名称" prop="type_name">
          <el-input v-model="localFormData.type_name" placeholder="请输入客服类型名称" maxlength="50" show-word-limit />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { addCustomerServiceType, updateCustomerServiceType } from '@/api/content/customerService'
import { defineEmits, defineProps, getCurrentInstance, reactive, ref, watch } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  dialogTitle: {
    type: String,
    default: '新增客服类型',
  },
  formData: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['update:visible', 'success'])

const { proxy } = getCurrentInstance()
const formRef = ref(null)
const loading = ref(false)

const localFormData = reactive({
  id: null,
  type_name: '',
})

const formRules = {
  type_name: [{ required: true, message: '请输入客服类型名称', trigger: 'blur' }],
}

watch(
  () => [props.visible, props.formData],
  () => {
    if (props.visible) {
      Object.assign(localFormData, {
        id: props.formData.id ?? null,
        type_name: props.formData.type_name ?? '',
      })
    }
  },
  { immediate: true }
)

function handleClose() {
  emit('update:visible', false)
}

function handleConfirm() {
  formRef.value.validate(valid => {
    if (!valid) return
    loading.value = true
    const api = localFormData.id ? updateCustomerServiceType : addCustomerServiceType
    const payload = { type_name: localFormData.type_name }
    if (localFormData.id) payload.id = localFormData.id
    api(payload)
      .then(res => {
        if (res && res.code !== undefined && res.code !== 0) {
          throw new Error(res.message || '保存失败')
        }
        proxy.$message.success('保存成功')
        emit('success')
        handleClose()
      })
      .catch(error => {
        console.error('保存客服类型失败', error)
        proxy.$message.error(error?.response?.data?.message || error.message || '保存客服类型失败')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>

<style lang="scss" scoped>
.dialog-fixed-height {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-fixed-height ::v-deep .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  margin: auto;
}
.dialog-fixed-height ::v-deep .el-dialog__header {
  flex-shrink: 0;
}
.dialog-fixed-height ::v-deep .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.dialog-fixed-height ::v-deep .el-dialog__footer {
  flex-shrink: 0;
}
</style>
